import * as Types from '../../../../../../graphql';

import { gql } from '@apollo/client';

/*
* This was automatically generated on by @graphql-codegen.
* DO NOT MANUALLY EDIT !!!
* Please refer to https://github.com/wistia/wistia/blob/main/frontend/graphql/README.md for more information.
* Last Updated: Fri Jul 25 2025 19:42:13 GMT+0000 (Coordinated Universal Time)
*/

export type RegistrationPageCustomizationsPartFragment = { __typename?: 'RegistrationPage', logoBakeryHashedId?: string | null | undefined, logoHeight?: number | null | undefined, logoTargetUrl?: string | null | undefined, logoRedirectUrl?: string | null | undefined, showLogo?: boolean | null | undefined, logoUrl?: string | null | undefined, shouldShowLogo?: boolean | null | undefined, showCopyButton: boolean, showCustomButton: boolean, customButtonText: string, customButtonUrl: string, formPlacement: Types.ElementPlacement, hasPoweredByWistiaBadge?: boolean | null | undefined, heroImageAltText?: string | null | undefined, heroImageBakeryHashedId?: string | null | undefined, heroImageHeight: number, heroImageUnsplashUrl?: string | null | undefined, heroImageUrl?: string | null | undefined, heroLetterboxStyle: Types.HeroLetterboxStyle, heroMediaType: Types.HeroMedia, heroVideoLetterboxColor?: string | null | undefined, heroVideoPlaybackType: Types.VideoPlayback, heroVideoPlaybarHidden: boolean, heroVideoPlayerColor?: string | null | undefined, heroVideoPlayerBorderRadius: number, titlePlacement: Types.ElementPlacement };

export const RegistrationPageCustomizationsPartFragmentDoc = gql`
    fragment RegistrationPageCustomizationsPart on RegistrationPage {
  logoBakeryHashedId
  logoHeight
  logoTargetUrl
  logoRedirectUrl
  showLogo
  logoUrl
  shouldShowLogo
  showCopyButton
  showCustomButton
  customButtonText
  customButtonUrl
  formPlacement
  hasPoweredByWistiaBadge
  heroImageAltText
  heroImageBakeryHashedId
  heroImageHeight
  heroImageUnsplashUrl
  heroImageUrl
  heroLetterboxStyle
  heroMediaType
  heroVideoLetterboxColor
  heroVideoPlaybackType
  heroVideoPlaybarHidden
  heroVideoPlayerColor
  heroVideoPlayerBorderRadius
  titlePlacement
}
    `;